export const cibSpreaker = ["32 32","<path d='M19.484 0l-7.516 8.719-11.266-2.427 11.578 9.828-11.385 9.953 11.214-2.646 7.682 8.573 0.948-11.469 10.557-4.646-10.62-4.438-1.182-11.448z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/brand/cib-spreaker.js
// module id = null
// module chunks = 